import VehiclesIcon from 'src/assets/icons/vehicles.svg?react';
import InternetIcon from 'src/assets/icons/internet.svg?react';
import InsuranceIcon from 'src/assets/icons/insurance.svg?react';
import HealthIcon from 'src/assets/icons/health.svg?react';
import SafetyIcon from 'src/assets/icons/safety.svg?react';
import PetsIcon from 'src/assets/icons/pets.svg?react';
import VehicleModsIcon from 'src/assets/icons/vehicle-maintenance.svg?react';
import RemoteWorkIcon from 'src/assets/icons/remote-work.svg?react';
import NavigationIcon from 'src/assets/icons/navigation.svg?react';
import FlightIcon from 'src/assets/icons/flight.svg?react';
import ShippingIcon from 'src/assets/icons/shipping.svg?react';
import LanguageIcon from 'src/assets/icons/language.svg?react';
import VehiclePurchaseIcon from 'src/assets/icons/vehicle-purchase.svg?react';
import PackingIcon from 'src/assets/icons/packing.svg?react';
import EnvironmentIcon from 'src/assets/icons/environment.svg?react';
import SeasonsIcon from 'src/assets/icons/seasons.svg?react';
import CommunityIcon from 'src/assets/icons/community.svg?react';
import KidsIcon from 'src/assets/icons/kids.svg?react';
import VisaIcon from 'src/assets/icons/visa.svg?react';
import CampingIcon from 'src/assets/icons/camping.svg?react';
import FoodIcon from 'src/assets/icons/food.svg?react';
import BorderIcon from 'src/assets/icons/border.svg?react';
import BudgetIcon from 'src/assets/icons/budget.svg?react';
import RouteIcon from 'src/assets/icons/route.svg?react';
import DrivingRulesIcon from 'src/assets/icons/driving-rules.svg?react';
import PrepAndPaperworkIcon from 'src/assets/icons/prep-and-paperwork.svg?react';
import DefaultIcon from 'src/assets/icons/route.svg?react';

export const handbookGroups = [
  {
    title: 'Planning & Preparation',
    color: '#33A7CC',
    categories: [
      {
        id: '68d48cff9c3b04e4e1b86ab5',
        slug: 'resources',
        title: 'Resources & Inspiration',
        description: 'The best blogs, youtube channels, books and more for planning your PanAm journey.',
        icon: RemoteWorkIcon,
        disabled: false
      },
      {
        id: '685eb22f28fb37eeb2664b58',
        slug: 'vehicles',
        title: 'Vehicles',
        description: 'Overview of the different vehicle types for driving the Pan American Highway.',
        icon: VehiclesIcon,
        disabled: false
      },
      {
        id: '685eb22f28fb37eeb2664b5a',
        slug: 'insurance',
        title: 'Insurance',
        description: 'Overview of vehicle and travel insurance for the PanAm.',
        icon: InsuranceIcon
      },
      {
        id: '685eb22f28fb37eeb2664b5d',
        slug: 'packing',
        title: 'Packing',
        description: 'What to pack for life on the road in all conditions.',
        icon: PackingIcon
      },
      {
        id: '685eb22f28fb37eeb2664b6e',
        slug: 'seasons',
        title: 'Time & Seasons',
        description: 'Best times to travel, avoid high season, and plan around weather.',
        icon: SeasonsIcon
      },
      {
        id: '685eb22f28fb37eeb2664b5f',
        slug: 'budget',
        title: 'Budget & Costs',
        description: 'Overview of how much PanAm travel really costs.',
        icon: BudgetIcon
      },
      {
        id: '685eb22f28fb37eeb2664b6d',
        slug: 'vehicle-purchase',
        title: 'Vehicle Purchase & Prep',
        description: 'How to buy, prep, and register a vehicle for PanAm travel.',
        icon: VehiclePurchaseIcon
      },
      {
        id: '685eb22f28fb37eeb2664b5b',
        slug: 'routes',
        title: 'Routes',
        description: 'Overview of the major route options, side trips, and regional breakdowns.',
        icon: RouteIcon
      },
      {
        id: '68bc9aefc99859c7d43c6990',
        slug: 'prep-and-paperwork',
        title: 'Prep & Paperwork',
        description: 'All the essential documents, permits, and preparations you need before hitting the Pan-American Highway.',
        icon: PrepAndPaperworkIcon
      },
    ]
  },
  {
    title: 'On The Road Essentials',
    color: '#589D62',
    categories: [
        {
          id: '685eb22f28fb37eeb2664b59',
          slug: 'internet',
          title: 'Internet',
          description: 'Guide to getting reliable internet across the PanAm.',
          icon: InternetIcon
        },
        {
          id: '685eb22f28fb37eeb2664b63',
          slug: 'vehicle-mods',
          title: 'Vehicle Mods',
          description: 'Useful upgrades for long-term PanAm travel.',
          icon: VehicleModsIcon
        },
        {
          id: '685eb22f28fb37eeb2664b5c',
          slug: 'borders',
          title: 'Border Crossings',
          description: 'What to expect at each border and how to prep.',
          icon: BorderIcon
        },
        {
          id: '685eb22f28fb37eeb2664b5e',
          slug: 'navigation',
          title: 'Navigation',
          description: 'How to find the best roads, campsites, and attractions.',
          icon: NavigationIcon
        },
        {
          id: '685eb22f28fb37eeb2664b60',
          slug: 'camping',
          title: 'Camping',
          description: 'How to find safe and scenic campsites.',
          icon: CampingIcon
        },
        {
          id: '685eb22f28fb37eeb2664b61',
          slug: 'visas',
          title: 'Visas',
          description: 'Overview of visa requirements for each country on the PanAm.',
          icon: VisaIcon
        },
        {
          id: '685eb22f28fb37eeb2664b66',
          slug: 'language',
          title: 'Language',
          description: 'Getting by in Spanish-speaking countries.',
          icon: LanguageIcon
        },
        {
          id: '685eb22f28fb37eeb2664b67',
          slug: 'food',
          title: 'Food',
          description: 'Street food, cooking, and grocery options on the road.',
          icon: FoodIcon
        },
        {
          id: '685eb22f28fb37eeb2664b6b',
          slug: 'remote-work',
          title: 'Remote Work & Income',
          description: 'How to earn while you travel – jobs, tools, and logistics.',
          icon: RemoteWorkIcon
        },
        {
          id: '685eb22f28fb37eeb2664b6c',
          slug: 'community',
          title: 'Community & Social',
          description: 'Meeting others on the road, events, and online groups.',
          icon: CommunityIcon
        },
    ]
  },
  {
    title: 'Logistcs & Travel Styles',
    color: '#3C6E9F',
    categories: [
        {
          id: '685eb22f28fb37eeb2664b69',
          slug: 'travelling-with-pets',
          title: 'Overlanding with Pets',
          description: 'Life on the road with animals – safety, paperwork, and routines.',
          icon: PetsIcon
        },
        {
          id: '685eb22f28fb37eeb2664b6a',
          slug: 'travelling-with-kids',
          title: 'Traveling with Kids',
          description: 'How families do the PanAm: education, safety, and setups.',
          icon: KidsIcon
        },
        {
          id: '685eb22f28fb37eeb2664b62',
          slug: 'shipping',
          title: 'Shipping & Storage',
          description: 'Moving vehicles and people across tricky sections.',
          icon: ShippingIcon
        },
    ]
  },
  {
    title: 'Responsible Travel',
    color: '#FF6E60',
    categories: [
        {
          id: '685eb22f28fb37eeb2664b64',
          slug: 'health',
          title: 'Health',
          description: 'Vaccinations, fitness, and staying healthy while overlanding.',
          icon: HealthIcon
        },
        {
          id: '685eb22f28fb37eeb2664b65',
          slug: 'safety',
          title: 'Safety',
          description: 'Staying safe across diverse regions.',
          icon: SafetyIcon
        },
        {
          id: '685eb22f28fb37eeb2664b68',
          slug: 'driving',
          title: 'Driving Rules',
          description: 'Permits, licenses, and common road hazards by country.',
          icon: DrivingRulesIcon
        },
        {
          id: '685eb22f28fb37eeb2664b6f',
          slug: 'environmental',
          title: 'Environmental Impact',
          description: 'Tips for traveling responsibly and reducing your footprint.',
          icon: EnvironmentIcon
        },
    ]
  }
];

export const getCategoryBySlug = (slug) => {
  for (const group of handbookGroups) {
    const match = group.categories.find(cat => cat.slug === slug);
    if (match) return { ...match, group };
  }
  return null;
};

export const getCategoryById = (id) => {
  for (const group of handbookGroups) {
    const match = group.categories.find(cat => cat.id === id);
    if (match) return { ...match, group };
  }
  return null;
};

export const getContentsIcon = (key) => {
  const map = {
    van: VehiclesIcon,
    jeep: VehiclePurchaseIcon,
    tools: VehicleModsIcon,
    map: NavigationIcon,
    insurance: InsuranceIcon,
    food: FoodIcon,
    safety: SafetyIcon,
    health: HealthIcon,
    budget: BudgetIcon,
    visa: VisaIcon,
    camping: CampingIcon,
    wrench: VehicleModsIcon,
    driving: DrivingRulesIcon,
    route: RouteIcon,
    pets: PetsIcon,
    kids: KidsIcon,
    internet: InternetIcon,
    shipping: ShippingIcon,
    language: LanguageIcon,
    community: CommunityIcon,
    remote: RemoteWorkIcon,
    packing: PackingIcon,
    border: BorderIcon,
    seasons: SeasonsIcon,
    environment: EnvironmentIcon,
    flight: FlightIcon,
    paperwork: PrepAndPaperworkIcon,

    default: DefaultIcon,
  };

  return map[key?.toLowerCase()] || DefaultIcon;
};